module.exports = __webpack_public_path__ + "img/time-off-early-late.b399824a.png";